module.exports = __webpack_public_path__ + "img/cust.296abe66.png";